import datatable_i18n_ko from "../../static/dataTables-1.12.1/plug-ins/i18n/ko.json";
import datatable_i18n_en from "../../static/dataTables-1.12.1/plug-ins/i18n/en.json";
import type {Config, ConfigLanguage} from "datatables.net";
import i18n from "i18next";

// FIXME useHooks!!! 필요!!!
const lang = i18n.language;
export const datatable_language_pack = lang.startsWith("en")
    ? datatable_i18n_en as ConfigLanguage
    : datatable_i18n_ko as ConfigLanguage;

type DtLanguage = NonNullable<Config["language"]>;

/** v1.12 언어팩을 v2 Config.language 모양으로 보정 */
function toV2Language(pack: unknown): DtLanguage {
    const p = (pack ?? {}) as {
        aria?: {
            sortAscending?: string;
            sortDescending?: string;
            orderable?: string;
            orderableReverse?: string;
            orderableRemove?: string;
        };
        paginate?: {
            first?: string;
            last?: string;
            next?: string;
            previous?: string;
            number?: string;
        };
        [k: string]: unknown;
    };

    const aria: DtLanguage["aria"] = {
        orderable: p.aria?.sortAscending ?? p.aria?.orderable ?? "",
        orderableReverse: p.aria?.sortDescending ?? p.aria?.orderableReverse ?? "",
        orderableRemove: p.aria?.orderableRemove ?? "",
        paginate: {
            first: p.paginate?.first,
            last: p.paginate?.last,
            next: p.paginate?.next,
            previous: p.paginate?.previous,
            number: p.paginate?.number,
        },
    };

    const obj: Record<string, unknown> = {...(pack ?? {})};
    delete (obj as { aria?: unknown }).aria;
    delete (obj as { paginate?: unknown }).paginate;

    return {...(obj as object), aria} as DtLanguage;
}

export const getDatatableLanguagePack = (lng?: string): DtLanguage => {
    const lang = (lng ?? i18n.language).toLowerCase();
    const raw = lang.startsWith("en") ? datatable_i18n_en : datatable_i18n_ko;
    return toV2Language(raw);
};